const params = new URLSearchParams(window.location.search);
const ref = params.get('utm_campaign');

if (ref) {
  localStorage.setItem('referrer', ref);
}

const header = document.querySelector('header');

if (
  document.body.classList.contains('template-index') &&
  document.body.classList.contains('page-grounded-by-ana')
) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
}

const toggle = document.querySelector('.menutoggle');
const nav = document.querySelector('nav');
toggle.addEventListener('click', (e) => {
  e.preventDefault();
    nav.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
});



$('body').on('click','.package', function(e){
  e.preventDefault();
  $('.package').removeClass('active');
  $(this).addClass('active');
  const qty = $(this).data('qty');
  $('#Quantity').val(qty);

  const varianid = $(this).find('.btn-selection-type.active').data('id');

  $('#id').val(varianid);
});

// $('body').on('click','.btn-selection-type', function(e){
  // e.preventDefault();
  // const tipo = $(this).data('type');
  // $('.btn-selection-type')
  //   .removeClass('active')
  //   .filter('[data-type="' + tipo + '"]')
  //   .addClass('active');
  //  $('.btn-selection-type').removeClass('active');
  //  $(this).addClass('active');
// });


$('body').on('click', '.change-locale', function(e) {
  e.preventDefault();

  const locale = $(this).data('locale');
  const country = $(this).data('country');

  // const form = document.getElementById('localization_form');
  const form = document.querySelector('form[action*="localization"]');

  if (!form) {
    console.error('Localization form no encontrado');
    return;
  }

  form.querySelector('[name="locale_code"]').value = locale;
  form.querySelector('[name="country_code"]').value = country;

  form.submit();
});



$('body').on('click', '.btn-selection-type', function(e) {
  e.preventDefault();

  const $btn = $(this);

  // 🔥 1. obtener package (abuelo)
  const $package = $btn.closest('.package');

  // qty real
  const qty = parseInt($package.data('qty'));

  // tipo (para sincronizar botones)
  const type = $btn.data('type');
  const varianid = $btn.data('id');

  // precio base (centavos → dinero)
  const basePrice = parseInt($btn.data('price')) / 100;

  // currency
  const currency = $btn.data('currency');

  // 🔥 2. activar botones del mismo tipo (todos los packages)
  // $('.btn-selection-type').removeClass('active');
  // $('.btn-selection-type[data-type="' + type + '"]').addClass('active');
  $package.find('.btn-selection-type').removeClass('active');
  $btn.addClass('active');


  // 🔥 3. activar package seleccionado
  $('.package').removeClass('active');
  $package.addClass('active');

  // 🔥 4. descuento por qty
  let discount = 0;
  if (qty === 2) discount = 0.10;
  if (qty === 3) discount = 0.15;

  // 🔥 5. cálculos
  const original = basePrice * qty;
  const final = original * (1 - discount);
  const unit = final / qty;

  // 🔥 6. formatter
  const formatter = new Intl.NumberFormat(
    currency === 'MXN' ? 'es-MX' : 'en-US',
    {
      style: 'currency',
      currency: currency
    }
  );

  $('#Quantity').val(qty);
  $('#id').val(varianid);


  // 🔥 7. pintar SOLO dentro del package
  $package.find('.priceing').html(`
    ${formatter.format(final)} ${currency}
    ${discount > 0 ? `<small>${formatter.format(original)} ${currency}</small>` : ''}
  `);

});





// $('body').on('click', '.imagethumbs a', function(e) {
//   e.preventDefault();
//   const src = $(this).attr('href');
//   $('#ProductPhotoImg').attr('src', src);
// });

$('body').on('click', '.imagethumbs a', function(e) {
  e.preventDefault();

  const $this = $(this);
  const src = $this.attr('href');
  const $wrapper = $('#ProductMediaWrapper');

  if ($this.hasClass('open-video')) {
    const videoHtml = `
      <video controls autoplay playsinline style="height:100%;display:block;margin:0 auto;max-height: 600px;">
        <source src="${src}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    `;
    $wrapper.html(videoHtml);

  } else {
    const imgHtml = `
      <img id="ProductPhotoImg" src="${src}" alt="">
    `;
    $wrapper.html(imgHtml);
  }
});


$('body').on('click', '.card-faq', function(e) {
  e.preventDefault();
  $(this).find('.answer').toggleClass('active');
});


$('body').on('click', '#js_add_cart', function(e) {
  e.preventDefault();
  $(this).html('');
  $(this).html(`<div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div>`);

  const items = [];
  $('.package.active .variant-select').each(function () {
    items.push({
      id: $(this).val(),
      quantity: 1
    });
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  })
  .then(() => {
    window.location.href = '/checkout';
  });
});


function updatePackagePricing($package) {
  const qty = parseInt($package.attr('data-qty')) || 1;
  const $selects = $package.find('.variant-select');

  let total = 0;
  let currency = 'USD';
  let variantIds = [];

  $selects.each(function() {
    const $selected = $(this).find('option:selected');
    const price = parseInt($selected.attr('data-price')) || 0;
    total += price / 100;
    currency = $selected.attr('data-currency') || 'USD';
    variantIds.push($selected.val());
  });

  let discount = 0;
  // if (qty === 2) {
  //   discount = 0.10;
  // }
  if (qty === 3) {
    discount = 0.10;
  }

  const original = total;
  const final = total * (1 - discount);

  const formatter = new Intl.NumberFormat(
    currency === 'MXN' ? 'es-MX' : 'en-US',
    {
      style: 'currency',
      currency: currency
    }
  );

  let html = `
    ${formatter.format(final)} ${currency}
  `;

  if (discount > 0) {
    html += `
      <small>${formatter.format(original)} ${currency}</small>
    `;
  }

  $package.find('.priceing').html(html);
  // console.log({
  //   qty,
  //   total,
  //   final,
  //   variantIds
  // });

}


$('body').on('change', '.variant-select', function() {
  const $package = $(this).closest('.package');
  // active visual
  $('.package').removeClass('active');
  $package.addClass('active');
  // recalcular
  updatePackagePricing($package);
});


// $('.package').each(function() {
//   updatePackagePricing($(this));
// });